import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../../../utils/axios';

export const addBankDetail = createAsyncThunk(
    'bank/addBankDetail',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const backendResponse = await axios.post(`/api/v2/bank-details`, data);
            dispatch(openBankModal(false));

            const response = {
                ...backendResponse?.data,
                code: backendResponse?.status
            }

            return response;
        } catch (error) {
            return rejectWithValue({
                ...error?.data,
                code: error?.status
            });
        }
    }
);

export const getAllBankDetailByUserId = createAsyncThunk(
    'bank/getAllBankDetailByUserId',
    async ({ user_id }, { rejectWithValue }) => {
        try {
            const backendResponse = await axios.get(`/api/v2/user_banks?user_id=${user_id}`);
            
            const response = {
                ...backendResponse?.data,
                code: backendResponse?.status
            }

            return response;
        } catch (error) {
            return rejectWithValue({
                ...error?.data,
                code: error?.status
            });
        }
    }
);

export const getBankDetailsById = createAsyncThunk(
    'bank/getBankDetailsById',
    async ({ id }, { rejectWithValue }) => {
        try {
            const backendResponse = await axios.get(`/api/v2/bank-details/${id}`);

            const response = {
                ...backendResponse?.data,
                code: backendResponse?.status
            }

            return response;
        } catch (error) {
            return rejectWithValue({
                ...error?.data,
                code: error?.status
            });
        }
    }
);

export const updateBankDetailsById = createAsyncThunk(
    'bank/updateBankDetailsById',
    async ({ id, data }, { rejectWithValue, dispatch }) => {
        try {
            const backendResponse = await axios.put(`/api/v2/bank-details/${id}`, data);
            dispatch(openEditModal(false));

            const response = {
                ...backendResponse?.data,
                code: backendResponse?.status
            }

            return response;
        } catch (error) {
            return rejectWithValue({
                ...error?.data,
                code: error?.status
            });
        }
    }
);

export const deleteBankDetailsById = createAsyncThunk(
    'bank/deleteBankDetailsById',
    async ({ id }, { rejectWithValue }) => {
        try {
            const backendResponse = await axios.delete(`/api/v2/bank-details/${id}`);

            const response = {
                ...backendResponse?.data,
                code: backendResponse?.status
            }

            return response;
        } catch (error) {
            return rejectWithValue({
                ...error?.data,
                code: error?.status
            });
        }
    }
);

const bankSlice = createSlice({
    name: 'bank',
    initialState: {
        bankDetails: null,
        bankRecord: null,
        loading: false,
        error: null,
        openEditModal: false,
        openAddBankModal: false,
        status: false
    },
    reducers: {
        setBankDetails: (state, action) => {
            state.bankDetails = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        openEditModal: (state, action) => {
            state.openEditModal = action.payload;
        },
        openBankModal: (state, action) => {
            state.openAddBankModal = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(addBankDetail.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addBankDetail.fulfilled, (state, action) => {
                state.loading = false;
                state.bankDetails = action.payload?.data;
                state.status = action.payload?.success;
                console.log('Bank details added successfully:', action.payload);
            })
            .addCase(addBankDetail.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                console.error('Failed to add bank details:', action.payload);
            });

        builder
            .addCase(getBankDetailsById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getBankDetailsById.fulfilled, (state, action) => {
                state.loading = false;
                state.bankRecord = action.payload;
                console.log('Bank details fetched successfully:', action.payload);
            })
            .addCase(getBankDetailsById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                console.error('Failed to fetch bank details:', action.payload);
            });

        builder
            .addCase(deleteBankDetailsById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteBankDetailsById.fulfilled, (state, action) => {
                state.loading = false;
                // state.bankDetails = action.payload;
                if (state.bankDetails && Array.isArray(state.bankDetails.data)) {
                    state.bankDetails.data = state.bankDetails.data.filter(
                        (bank) => bank.id !== action.meta.arg.id
                    );
                }
                console.log('Bank details deleted successfully:', action.payload);
            })
            .addCase(deleteBankDetailsById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                console.error('Failed to delete bank details:', action.payload);
            });

        builder
            .addCase(getAllBankDetailByUserId.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllBankDetailByUserId.fulfilled, (state, action) => {
                state.loading = false;
                state.bankDetails = action.payload;
                // console.log('All bank details fetched successfully:', action.payload);
            })
            .addCase(getAllBankDetailByUserId.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                console.error('Failed to fetch all bank details:', action.payload);
            });

        builder
            .addCase(updateBankDetailsById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateBankDetailsById.fulfilled, (state, action) => {
                state.loading = false;
                if (state.bankDetails && Array.isArray(state.bankDetails.data)) {
                    const index = state.bankDetails.data.findIndex(
                        (bank) => bank.id === action.payload.id
                    );
                    if (index !== -1) {
                        state.bankDetails.data[index] = action.payload;
                    }
                }
                // console.log("Bank details updated successfully:", action.payload);
            })
            .addCase(updateBankDetailsById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                console.error('Failed to update bank details:', action.payload);
            });
    }
});

export const { setBankDetails, setLoading, setError, openEditModal, openBankModal } =
    bankSlice.actions;

export default bankSlice.reducer;
